import { z } from "zod";
export const SEAT_COUNT = 4;
/** Games at the table (PLAN §0.3, ADR 0018); the lobby owner picks one before the start. */
export const variantSchema = z.enum([
    "batak",
    "spades",
    "tarneeb",
    "baloot",
    "hearts",
    "king",
    "pisti",
]);
export const VARIANTS = variantSchema.options;
export const tempoSchema = z.enum(["relaxed", "normal", "fast"]);
export const seatIndexSchema = z
    .number()
    .int()
    .min(0)
    .max(SEAT_COUNT - 1);
/** House rules per game (slice 0013): the engine knows the keys; here only the shape. */
export const rulesSchema = z.record(z.string(), z.union([z.boolean(), z.number()]));
/** What a table is configured to play. `goal` null means play `length` hands. */
export const tableSettingsSchema = z.object({
    variant: variantSchema,
    tempo: tempoSchema,
    goal: z.number().int().positive().nullable(),
    length: z.number().int().positive(),
    rules: rulesSchema.default({}),
});
export const tableStatusSchema = z.enum(["lobby", "countdown", "playing", "finished"]);
/**
 * Scenes (ADR 0023, 0030): a room picture and a table picture, the owner's choice, seen by
 * everyone. Free first: `istanbul` (the default), `otel`, `majlis`; then Club: `orman`, `uzay`,
 * `neon` (owner, 14 Sept 2026).
 */
export const sceneIdSchema = z.enum(["istanbul", "otel", "majlis", "orman", "uzay", "neon"]);
export const SCENE_IDS = sceneIdSchema.options;
export const DEFAULT_SCENE = "istanbul";
/** A seated player as every client sees it. Identity comes from Discord; the shell fills it. */
export const seatInfoSchema = z.object({
    seat: seatIndexSchema,
    userId: z.string().min(1),
    name: z.string(),
    avatar: z.string().nullable(),
    bot: z.boolean(),
    connected: z.boolean(),
    /** The clock ran out on this seat often enough that the table plays it (review 0024 decision 173). */
    auto: z.boolean().optional(),
});
export const memberSchema = z.object({
    userId: z.string().min(1),
    name: z.string(),
    avatar: z.string().nullable(),
});
/**
 * An open table as the tables list shows it (slice 0012): enough to choose,
 * nothing private. `open` counts empty seats, `humans` the people seated.
 */
export const listingSchema = z.object({
    id: z.string().min(1),
    variant: variantSchema,
    tempo: tempoSchema,
    goal: z.number().int().positive().nullable(),
    length: z.number().int().positive(),
    status: tableStatusSchema,
    humans: z.number().int().nonnegative(),
    open: z.number().int().nonnegative(),
    host: memberSchema.nullable(),
    scene: sceneIdSchema,
    /** A table the queue formed (review 0020): standard settings, filled by "Find players". */
    queue: z.boolean().optional(),
    /** The humans seated, by id: a seat promised by the queue is free again once its player sits. */
    seated: z.array(z.string()).optional(),
    /** Players the owner removed: the queue never sends them back here. Server side only. */
    barred: z.array(z.string()).optional(),
    updatedAt: z.number().int().nonnegative(),
});
//# sourceMappingURL=table.js.map